class User {
  constructor (data) {
    data.settings = data.settings.data

    Object.assign(this, data)
  }

  isMemberOf (team) {
    return team.role_id <= 3
  }

  isUserOf (team) {
    return team.role_id <= 2
  }

  isAdminOf (team) {
    return team.role_id <= 1
  }

  isOwnerOf (team) {
    return team.role_id === 0
  }

  isMemberOfActiveTeam () {
    return this.role <= 3
  }

  isUserOfActiveTeam () {
    return this.role <= 2
  }

  isAdminOfActiveTeam () {
    return this.role <= 1
  }

  isOwnerOfActiveTeam () {
    return this.role === 0
  }
}

export default User
